import { Brand, prettyPrintBrand } from '../context/claims';
import { env } from './env';

export default function setBrandSpecificHeadMetaData(brand: Brand): void {
  const publicUrl = env.BASE_URL.replace(/\/$/, '');

  const faviconElm = document.getElementById('favicon');
  const descriptionElm = document.getElementById('description');
  const themeColorMetaElm = document.querySelector('meta[name="theme-color"]');

  switch (brand) {
    case Brand.VIPPS:
      document.title = prettyPrintBrand(brand);
      themeColorMetaElm?.setAttribute('content', '#ff5b24'); // --vipps-orange-50
      faviconElm?.setAttribute('href', `${publicUrl}/favicon_vipps.ico`);
      descriptionElm?.setAttribute('content', 'Landing page for Vipps online payments');
      break;
    case Brand.MOBILEPAY:
      document.title = prettyPrintBrand(brand);
      themeColorMetaElm?.setAttribute('content', '#5a78ff'); // --mobilepay-blue-100
      faviconElm?.setAttribute('href', `${publicUrl}/favicon_mobilepay.ico`);
      descriptionElm?.setAttribute('content', 'Mobilepay');
  }
}
